import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {CrossIcon} from '../../icons/cross-icon';
import {CSS_CONSTANTS} from '../../css_variables';

const EmailLabelContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 4px 4px 4px 4px;
	border: 1px solid #c4c4cc;
	box-sizing: border-box;
	border-radius: 4px;
	width: min-content;
	:focus {
		outline: none;
		border-color: ${CSS_CONSTANTS.v2_branding_purple};
	}
`;

const CrossIconWrapper = styled.div`
	margin-left: 8px;
`;
const EmailLabelText = styled.div`
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 16px;
	letter-spacing: 0em;
`;

const BoldText = styled.div`
	font-size: 11px;
	font-style: normal;
	font-weight: 700;
	line-height: 16px;
	letter-spacing: 0em;
	margin-left: 4px;
`;

// eslint-disable-next-line react/display-name
export const EmailLabel = React.forwardRef(({text, boldText, onCrossClick, tabIndex}, ref) => {
	return (
		<EmailLabelContainer ref={ref} tabIndex={tabIndex}>
			<EmailLabelText>{text}</EmailLabelText>
			{boldText && <BoldText>{boldText}</BoldText>}
			<CrossIconWrapper>
				<CrossIcon onClick={onCrossClick} size={CrossIcon.SIZE.SMALL} color="#4C4C58" />
			</CrossIconWrapper>
		</EmailLabelContainer>
	);
});

EmailLabel.propTypes = {
	text: PropTypes.string,
	onCrossClick: PropTypes.func,
	boldText: PropTypes.string,
	tabIndex: PropTypes.number,
};
